/**
 * 카테고리 목록 조회 커스텀 훅
 *
 * react-query를 사용하여 카테고리 데이터를 fetch하고 캐싱
 * - 전체 목록 조회 (페이지네이션 없음)
 * - 계층 구조 정보 포함
 */

import { useQuery } from "@tanstack/react-query";
import { getCategories } from "../api/categoryApi";

/**
 * 카테고리 목록 조회 훅
 *
 * @returns react-query의 useQuery 결과 (data, isLoading, isError 등)
 */
export const useCategories = () => {
  return useQuery({
    queryKey: ["categories"],
    queryFn: getCategories,
    staleTime: 1000 * 60 * 10, // 10분간 캐시 유지 (카테고리는 자주 변경되지 않음)
    gcTime: 1000 * 60 * 30, // 30분간 가비지 컬렉션 유예
  });
};
